import GLightbox from 'glightbox'

const initAuctionGlightBox = () => {
  GLightbox({
    selector: '.auction-glightbox'
  });
}

export default initAuctionGlightBox;
